<div class="multi-camera-file-container">
  <!-- Lista de items (fotos e arquivos) -->
  <div *ngIf="items.length > 0" class="items-list">
    <div *ngFor="let item of items" class="item-card" [ngClass]="'item-' + item.type">
      <!-- Foto -->
      <div *ngIf="item.type === 'photo'" class="photo-item">
        <div *ngIf="item.loadingUrl" class="photo-loading">
          <mat-spinner diameter="40"></mat-spinner>
        </div>
        <img 
          *ngIf="!item.loadingUrl" 
          [src]="item.displayValue || item.value" 
          alt="Captured photo" 
          class="photo-thumbnail" 
        />
        <button mat-icon-button color="warn" (click)="removeItem(item.id)" class="remove-btn">
          <mat-icon>delete</mat-icon>
        </button>
      </div>

      <!-- Arquivo -->
      <div *ngIf="item.type === 'file'" class="file-item">
        <div *ngIf="item.loadingUrl" class="file-loading">
          <mat-spinner diameter="24"></mat-spinner>
        </div>
        <mat-icon *ngIf="!item.loadingUrl" class="file-icon">insert_drive_file</mat-icon>
        <span class="file-name">{{ item.name }}</span>
        <button mat-icon-button color="warn" (click)="removeItem(item.id)" class="remove-btn">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <!-- Contador -->
  <div *ngIf="items.length > 0" class="items-counter">
    {{ items.length }} / {{ maxFiles }} {{ items.length === 1 ? 'item' : 'items' }}
  </div>

  <!-- Botões de ação -->
  <div *ngIf="canAddMore" class="action-buttons">
    <button
      mat-raised-button
      (click)="openCameraModal()"
      [disabled]="isLoading"
      class="action-btn camera-btn"
    >
      <mat-icon>camera_alt</mat-icon>
      Tirar foto
    </button>

    <span class="separator">ou</span>

    <button
      mat-raised-button
      (click)="openUploadModal()"
      [disabled]="isLoading"
      class="action-btn upload-btn"
    >
      <mat-icon>upload_file</mat-icon>
      Selecionar arquivo(s)
    </button>
  </div>

  <!-- Mensagem de limite atingido -->
  <div *ngIf="!canAddMore" class="limit-message">
    <mat-icon>info</mat-icon>
    <span>Limite máximo de {{ maxFiles }} arquivo(s) atingido.</span>
  </div>

  <!-- Loading spinner -->
  <div *ngIf="isLoading" class="loading-overlay">
    <mat-spinner diameter="50"></mat-spinner>
  </div>
</div>
